import React from 'react';
import PropTypes from 'prop-types';
import { usePdfTemplateContext } from '@hydra/common/context/pdfTemplate';

export const Dot = ({ cx, cy, stroke }) => {
  const { pdfTheme } = usePdfTemplateContext();
  return pdfTheme === 'modern'
    ? <circle cx={cx} cy={cy} r={3} stroke={stroke} strokeWidth={2} fill='white' />
    : <circle cx={cx} cy={cy} r={1.5} stroke={stroke} strokeWidth={1} fill={stroke} />;
};

Dot.propTypes = {
  cx: PropTypes.number,
  cy: PropTypes.number,
  fill: PropTypes.string,
  stroke: PropTypes.string
};

export default Dot;
